import type { SupportedLocale } from "./i18n";

/** Extracts localized string from product.about or product.historicalBackground */
export function getLocalizedText(
  value: string | Record<string, string> | undefined,
  locale: SupportedLocale
): string | undefined {
  if (!value) return undefined;
  if (typeof value === "string") return value;
  return value[locale] ?? value.en ?? Object.values(value)[0];
}
